import request from "@/components/common/utils/request.js"

export function api_findeByAsin(data) {
	return request({
		url: '/api/asinBasicInfo/findeByAsin',
		method: 'get',
		params : data
	})
}

export function api_asin_search(data) {
	return request({
		url: '/api/asinBasicInfo/search',
		method: 'get',
		params : data
	})
}

export function api_asin_getAsinInfo(asin,site) {
	return request({
		url: '/api/asinBasicInfo/getAsinInfo',
		method: 'get',
		params : {
			asin : asin,
			site : site
		}
	})
}


export function api_asin_setGroup(groupId,asinGroupUser) {
	return request({
		url: '/api/asinBasicInfo/setGroup',
		method: 'get',
		params : {
			groupId : groupId,
			keywordUserId : asinGroupUser
		}
	})
}

export function api_asin_delAsinById(id){
	return request({
		url: '/api/asinBasicInfo/del',
		method: 'get',
		params : {
			asinGroupUserId : id
		}
	})
}

export function api_asin_keywordsRelatedList(id,b){
	return request({
		url: '/api/asinBasicInfo/keywordsRelatedList',
		method: 'get',
		params : {
			asinId : id,
			hasChart : b
		}
	})
}

export function api_asin_getAsinChartData(id,timeType){
	return request({
		url: '/api/asinBasicInfo/getAsinChartData',
		method: 'get',
		params : {
			asinId : id,
			timeType : timeType
		}
	})
}

export function api_asin_updateAsinInfo(asin,country){
	return request({
		url: '/api/asinBasicInfo/update',
		method: 'get',
		params : {
			asin : asin,
			country : country
		}
	})
}


export function api_asin_batchAsinInfoQuery_public(arr, site, fields){
	return request({
		url: '/api/asinBasicInfo/public/batchAsinInfoQuery',
		method: 'post',
		data : {
			asins : arr,
			site : site,
			fields : fields
		}
	})
}

export function api_asin_getAsinSimple(asin, country){
	return request({
		url: '/api/asinBasicInfo/getAsinSimpleAndTrafficSources',
		method: 'get',
		params : {
			asin : asin,
			country : country
		}
	})
}

export function api_asin_bulkGetTrafficSources(data){
	return request({
		url: '/api/asinBasicInfo/bulkGetTrafficSources',
		method: 'post',
		data : data
	})
}

export function api_asin_queryAsinMetrics(data){
	return request({
		url: '/api/asinBasicInfo/queryAsinMetrics',
		method: 'post',
		data : data
	})
}